var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":"show-image-modal","hide-header":"","hide-footer":"","centered":"","size":"lg"}},[_c('expandable-image',{attrs:{"src":_vm.getFullImageUrl(_vm.filename),"fluid":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }